import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Button, Card } from "../components/ui";

export function Home() {
  return (
    <>
      <Helmet>
        <title>WishList Hub — списки подарков</title>
        <meta
          name="description"
          content="Создайте список желаний и поделитесь ссылкой. Гости бронируют подарки без регистрации."
        />
      </Helmet>
      <div className="space-y-10">
        <section className="text-center">
          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Списки подарков без лишних забот
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-lg text-slate-400">
            Создайте страницу с желаниями, отправьте ссылку друзьям. Они зарезервируют подарок — без
            дубликатов и без обязательной регистрации.
          </p>
          <div className="mt-8 flex justify-center gap-4">
            <Link to="/create">
              <Button>Создать список</Button>
            </Link>
            <Link to="/auth/register">
              <Button variant="secondary">С аккаунтом</Button>
            </Link>
          </div>
        </section>
        <div className="grid gap-4 sm:grid-cols-3">
          {[
            ["Публичная ссылка", "Каждый список открывается по уникальному адресу."],
            ["Бронирование", "Гости оставляют имя и могут отменить бронь по секретной ссылке."],
            ["Режим сюрприз", "Забронированные позиции можно скрыть от именинника."],
          ].map(([t, d]) => (
            <Card key={t}>
              <h3 className="font-semibold text-white">{t}</h3>
              <p className="mt-2 text-sm text-slate-400">{d}</p>
            </Card>
          ))}
        </div>
      </div>
    </>
  );
}
